import { Link } from 'react-router-dom';
import { BRAND_FULL_NAME, MAIN_SITE_URL } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="py-12 bg-secondary-500 text-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          <div>
            <h4 className="font-heading text-lg font-bold mb-3">{BRAND_FULL_NAME}</h4>
            <p className="text-sm text-background-50/70 leading-relaxed">
              Your complete resource for spreadsheet solutions, data management guides, and productivity tools. Helping businesses and individuals organize data smarter.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-base font-bold mb-3">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/vigorbuy-spreadsheet-complete-guide" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">
                  Complete Guide
                </Link>
              </li>
              <li>
                <a href={MAIN_SITE_URL} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">
                  Main Store
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-base font-bold mb-3">Shop Categories</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">Shoes</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">T-Shirts</a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">Jackets</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-background-50/15 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} {BRAND_FULL_NAME}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href={MAIN_SITE_URL} target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50/70 transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href={MAIN_SITE_URL} target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50/70 transition-colors cursor-pointer">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}